import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { PipesModule } from '../dave-utils-module/dave-shared-components-module/pipes/pipes.module';
import { IconPipeModule } from '../dave-utils-module/icon-pipe/icon-pipe.module';
import { EventListEntryComponent } from './components/event-list-entry/event-list-entry.component';



@NgModule({
    declarations: [EventListEntryComponent],
    imports: [
        CommonModule,
        FontAwesomeModule,
        MatTooltipModule,
        IconPipeModule,
        MatDividerModule,
        PipesModule,
        AppButtonModule,
        RouterModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatBadgeModule,
        MatCheckboxModule,
        FormsModule,
        DaveLoadingModule,
    ],
    exports: [EventListEntryComponent],
})
export class DaveEventListEntryModule {}
